module.exports = __webpack_public_path__ + "img/gx_04.6ddd6ce0.png";